/* 456 Print Co - Page Loader
   CSS animation handles the bar fill. JS waits for bar + video ready, then dismisses.
   Loader only shows on first homepage visit per session (controlled in theme.liquid). */
document.addEventListener('DOMContentLoaded', function() {
  var loaderFill = document.getElementById('loaderFill');
  var pageLoader = document.getElementById('pageLoader');
  if (!loaderFill || !pageLoader) return;

  /* If loader is hidden (non-homepage or repeat visit), fire hero anims immediately */
  if (pageLoader.style.display === 'none' || getComputedStyle(pageLoader).display === 'none') {
    if (typeof window.initHeroAnimations === 'function') window.initHeroAnimations();
    setTimeout(function() {
      if (typeof window.triggerDiceRoll === 'function') window.triggerDiceRoll();
    }, 300);
    return;
  }

  var video = document.querySelector('.hero-video__media video');
  var videoReady = false;
  var barDone = false;

  if (video) {
    video.muted = true;
    video.setAttribute('muted', '');
  }

  function dismiss() {
    if (typeof gsap !== 'undefined') {
      gsap.to(pageLoader, {
        opacity: 0,
        duration: 0.5,
        ease: 'power2.inOut',
        onComplete: function() {
          pageLoader.style.display = 'none';
          if (typeof window.initHeroAnimations === 'function') window.initHeroAnimations();
          setTimeout(function() {
            if (typeof window.triggerDiceRoll === 'function') window.triggerDiceRoll();
          }, 600);
        }
      });
    } else {
      pageLoader.style.opacity = '0';
      setTimeout(function() {
        pageLoader.style.display = 'none';
        if (typeof window.initHeroAnimations === 'function') window.initHeroAnimations();
      }, 500);
    }
  }

  function tryDismiss() {
    if (barDone && videoReady) dismiss();
  }

  /* Bar animation is CSS-driven. Listen for animationend to know it's done. */
  loaderFill.addEventListener('animationend', function() {
    barDone = true;
    tryDismiss();
  });
  /* Safety: if animationend doesn't fire (e.g. already finished), check after 2s */
  setTimeout(function() { barDone = true; tryDismiss(); }, 2100);

  if (video) {
    if (video.readyState >= 3) {
      videoReady = true;
    } else {
      video.addEventListener('canplay', function() {
        videoReady = true;
        tryDismiss();
      }, { once: true });
    }
    setTimeout(function() { videoReady = true; tryDismiss(); }, 5000);
  } else {
    videoReady = true;
  }
});